<template>
  <b-card-code :title="ifEdit ? 'Edit Template' : 'Add Template'">
    <validation-observer ref="simpleRules">
      <b-form @submit.prevent="submitForm">
        <b-row>
          <b-col md="12">
            <b-form-group>
              <label>Type</label>
              <label style="color: red !important">*</label>
              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Type"
              >
                <v-select
                  v-model="type"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  placeholder="None"
                  :options="['SMS', 'Email', 'Whatsapp', 'Document', 'Other']"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group>
              <label>Template Name</label>
              <label style="color: red !important">*</label>
              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Template Name"
              >
                <b-form-input
                  v-model="templateName"
                  type="text"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  placeholder="Enter Template Name"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <template v-if="type === 'Whatsapp'">
            <b-col md="6">
              <b-form-group>
                <label>WhatsApp Template Name</label>
                <label style="color: red !important">*</label>
                <validation-provider
                  #default="{ errors }"
                  rules="required"
                  name="WhatsApp Template Name"
                >
                  <b-form-input
                    v-model="whatsappTemplateName"
                    type="text"
                    placeholder="e.g. sitevisit_cancel_client"
                  />
                  <small class="text-muted">Campaign / template name used when sending WhatsApp</small>
                  <small class="text-danger d-block">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label>WhatsApp Template ID</label>
                <label style="color: red !important">*</label>
                <validation-provider
                  #default="{ errors }"
                  rules="required"
                  name="WhatsApp Template ID"
                >
                  <b-form-input
                    v-model="whatsappTemplateId"
                    type="text"
                    placeholder="e.g. 1234567890123456"
                  />
                  <small class="text-muted">Template ID from WhatsApp Business / provider</small>
                  <small class="text-danger d-block">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </template>
          <b-col cols="12" v-if="type == 'SMS' || type == 'Whatsapp'">
            <label>Details</label>
            <validation-provider
              #default="{ errors }"
              rules="required"
              name="Details"
            >
              <quill-editor v-model="details" />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
          <b-col md="12" v-else>
            <b-form-group>
              <label for="textarea-default">Details</label>
              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Details"
              >
                <b-form-textarea
                  v-model="details"
                  placeholder="Enter Details"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="12"
            ><br />
            <b-button
              variant="primary"
              type="submit"
              @click.prevent="submitForm($event)"
              class="mr-4"
            >
              Submit
            </b-button>
            <b-button variant="primary" @click="onClickBack">Back </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>

    <!-- <template #code>
      {{ codeType }}
    </template> -->
  </b-card-code>
</template>

<script>
import BCardCode from "@core/components/b-card-code";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import PinchScrollZoom from "@coddicat/vue-pinch-scroll-zoom";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
// eslint-disable-next-line
import "quill/dist/quill.core.css";
// eslint-disable-next-line
import "quill/dist/quill.snow.css";
// eslint-disable-next-line
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

import {
  BFormInput,
  BFormGroup,
  BForm,
  BRow,
  BInputGroupAppend,
  BCol,
  BInputGroup,
  BButton,
  BFormTextarea,
  BFormDatepicker,
  BImgLazy,
  BFormFile,
} from "bootstrap-vue";
import {
  required,
  email,
  confirmed,
  url,
  between,
  alpha,
  integer,
  password,
  min,
  digits,
  alphaDash,
  length,
  min_value,
} from "@validations";
import vSelect from "vue-select";
import axios from '@/components/axios';
import moment from "moment";

export default {
  props: ["closepopup", "getGridData", "selectedID"],
  components: {
    quillEditor,
    PinchScrollZoom,
    BCardCode,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    vSelect,
    BFormDatepicker,
    BFormTextarea,
    BImgLazy,
    BFormFile,
    BCardCode,
  },
  data() {
    return {
      accessToken: localStorage.getItem("accessToken"),
      baseApi: process.env.VUE_APP_APIENDPOINT,
      details: "",
      type: "",
      templateName: "",
      whatsappTemplateName: "",
      whatsappTemplateId: "",
      ifEdit: false,
      flag: false,
    };
  },
  watch: {
    type(newType) {
      if (newType !== "Whatsapp") {
        this.whatsappTemplateName = "";
        this.whatsappTemplateId = "";
      }
    },
  },
  mounted() {
    const role = JSON.parse(localStorage.getItem("userData")).role;
    if (role !== "admin") {
      this.$router.push("/");
    }
    this.ifEdit = !!this.selectedID;
    this.ifEdit && this.getEditValue();
  },
  methods: {
    async getEditValue() {
      await axios({
        method: "GET",
        url: `${this.baseApi}/gettemplateById/${this.selectedID}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
      })
        .then((json) => {
          this.getEditItems(json.data.data);
        })
        .catch((error) => console.log(error, "error"));
    },
    getEditItems(item) {
      item.map((item) => {
        this.details = item.description;
        this.type = item.subject;
        this.templateName = item.name;
        this.whatsappTemplateName = item.whatsapp_template_name || "";
        this.whatsappTemplateId = item.whatsapp_template_id || "";
      });
    },
    onClickBack() {
      this.closepopup();
    },
    submitForm(e) {
      const data = {
        description: this.details,
        subject: this.type,
        name: this.templateName,
        whatsapp_template_name: this.type === "Whatsapp" ? this.whatsappTemplateName : null,
        whatsapp_template_id: this.type === "Whatsapp" ? this.whatsappTemplateId : null,
      };
      this.$refs.simpleRules.validate().then(async (success) => {
        if (success == false) {
          this.$swal({
            title: "Warning",
            timer: 5000,
            text: "Plese Fill the All Field",
            icon: "warning",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
        }
        if (success) {
          this.flag = true;
          const accessToken = localStorage.getItem("accessToken");
          const baseApi = process.env.VUE_APP_APIENDPOINT;
          await axios({
            method: `${this.ifEdit ? "put" : "post"}`,
            url: this.ifEdit
              ? `${baseApi}/template/${this.selectedID}`
              : `${baseApi}/template`,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
            data: JSON.stringify(data),
          })
            .then((response) => {
              this.flag = false;

              this.$swal({
                title: "Submited",
                text: response.data.message
                  ? `${response.data.message}`
                  : response.data.success
                  ? `${response.data.success}`
                  : "Update SuccessFully",
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                buttonsStyling: false,
              });
              this.closepopup();
              this.getGridData();
            })
            .catch((error) => {
              this.flag = false;

              this.$swal({
                title: "Error!",
                text: `${error}`,
                icon: "error",
                timer: 5000,
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
  },
};
</script>
